import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminLayout from './components/AdminLayout';
import Login from './pages/Login';
import AuthCallback from './pages/AuthCallback';
import Dashboard from './pages/Dashboard';
import PlacesList from './pages/PlacesList.jsx';
import PlaceForm from './pages/PlaceForm.jsx';
import Festivals from './pages/Festivals.jsx';
import FestivalForm from './pages/FestivalForm.jsx';
import Journals from './pages/Journals.jsx';
import Feedback from './pages/Feedback';
import Analytics from './pages/Analytics';
import ViewData from './pages/ViewData';
import Users from './pages/Users.jsx';

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          {/* Protected Admin Routes */}
          <Route
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="places" element={<PlacesList />} />
            <Route path="places/new" element={<PlaceForm />} />
            <Route path="places/edit/:id" element={<PlaceForm />} />
            <Route path="festivals" element={<Festivals />} />
            <Route path="festivals/new" element={<FestivalForm />} />
            <Route path="festivals/edit/:id" element={<FestivalForm />} />
            <Route path="journals" element={<Journals />} />
            <Route path="feedback" element={<Feedback />} />
            <Route path="users" element={<Users />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="view-data" element={<ViewData />} />
          </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
